export default __webpack_public_path__ + "static/media/no_pass_person.efc95474.png";